import { Component, OnInit } from '@angular/core';
import { UserProfile_Document } from '../../model/user-profile';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { AppService } from '../../services/app.service';
import { UserProfileService } from '../../services/user-profile.service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css'],
  providers: [UserProfileService]
})
export class MyProfileComponent implements OnInit {
  Doc: UserProfile_Document;
  selectedEnabled: any;

  Title: string = 'Modify';
  dropdownSettings = {};

  constructor(private appService: AppService, private dlgService: DialogService,
    UserService: UserProfileService) {
    this.Doc = new UserProfile_Document(dlgService, UserService);
    this.Doc.UserAccount = '';
    this.Doc.SelectEnabled = 'Y';
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'text',
      itemsShowLimit: 6,
      allowSearchFilter: false
    };
  }

  ngOnInit() {
    this.Doc.GetMyDocumemt((data) => { this.OnDataSrvEnd(); });
    this.Title = 'Edit';
  }

  isValid(): boolean {
    return true;
  }

  Submit($event) {
    this.Doc.Save().subscribe(data => {
      if (data.Success) {
        let result = this.dlgService.SingleButtonSubmit();
        result.then((ret) => {
        }).catch((error) => {
          console.error(error);
        });
      }
      else {
        this.dlgService.ErrorInformation(data.Message)
      }
    });
  }

  OnDataSrvEnd() {
    setTimeout(() => this.appService.SetLoadingState(false), 0);
  }
}
